import { COMPANY_MODEL, Company, ICompanyForm } from "@app/models";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import {
  createFormGroupState,
  FormGroupState,
  markAsPristine,
  onNgrxForms,
  setValue,
  unbox,
  updateGroup,
  validate,
  wrapReducerWithFormStateUpdate,
} from "ngrx-forms";
import { required } from "ngrx-forms/validation";
import { AuthApiActions, CompanyApiActions } from "../actions";

export const FORM_ID = COMPANY_MODEL;

export interface CompanyState extends EntityState<Company> {
  selectedId: number;
  form: FormGroupState<ICompanyForm>;
}

export const initialFormGroupValue: ICompanyForm = {
  company_id: null,
};

export const adapter: EntityAdapter<Company> = createEntityAdapter<Company>({
  selectId: (company: Company) => company.id,
  sortComparer: false,
});

export const initialState: CompanyState = adapter.getInitialState({
  selectedId: null,
  form: createFormGroupState<ICompanyForm>(FORM_ID, initialFormGroupValue),
});

const validateFormState = updateGroup<ICompanyForm>({
  company_id: validate(required),
});

export const rawReducer = createReducer(
  initialState,
  onNgrxForms(),

  on(CompanyApiActions.setCompanies, (state, { companies, selectedId }) =>
    adapter.setAll(companies, { ...state, selectedId: selectedId })
  ),

  on(CompanyApiActions.setFormControls, (state, { companyForm }) => ({
    ...state,
    form: markAsPristine(setValue(state.form, companyForm)),
  })),

  on(AuthApiActions.setCompanySuccess, (state) => ({
    ...state,
    selectedId: unbox(state.form.value).company_id.id,
    form: markAsPristine(state.form),
  }))
);

export const companyReducer = wrapReducerWithFormStateUpdate(
  rawReducer,
  (s) => s.form,
  validateFormState
);

export const selectId = (state: CompanyState) => state.selectedId;

export const selectForm = (state: CompanyState) => state.form;
